import React from 'react';
import { Input, Button, Select, Viewer, Modal, Pagination, Tooltip } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission } from 'utils';
import { connect } from 'react-redux';
import { 
	CheckWhiteIcon, 
	AddIcon, 
	VerificationManualIcon, 
	FaceIcon, 
	CheckUserIcon, 
	IdCardIcon, 
	CloseIcon,
	SalarymanIcon,
	FaceIdentityIcon,
	AlertIcon,
	BlackListIcon,
	BlackListRedIcon,
	EditIcon,
	Menu as MenuIcons,
	ShieldIcon,
	LockIcon,
	BlackListBlueIcon,
	PencilIcon,
	InfoIcon,
	FormIcon2,
	ScanIcon,
	ListIcon,
	ArrowLeftBlack,
	ArrowRightBlack
} from 'assets/icons';
import moment from 'moment';
import { ReportService } from 'services';
import { PhotoBg1, PhotoBg2 } from 'assets/img';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const PHOTOS_ACTIVE = {
	DOCUMENT_PHOTO: 'document_photo',
	DOCUMENT_BACK_PHOTO: 'document_back_photo'
}

class ViewVerification extends React.Component<Props> {

	state = {
		verification: null,
		file: null,
		visible: false,
		visible_modal: false,
		type: null,
		identity_token: null,
		page: 1,
		last_page: 1,
		black_list: [],
		visible_update: false,
		first_load: true,
		form: {
			document: '',
			document_type_id: ''
		},
		document_types: [
			{ value: Constants.DOCUMENT_TYPES.V.toString(), label: 'V-' },
			{ value: Constants.DOCUMENT_TYPES.E.toString(), label: 'E-' },
			{ value: Constants.DOCUMENT_TYPES.J.toString(), label: 'J-' },
			{ value: Constants.DOCUMENT_TYPES.G.toString(), label: 'G-' },
			{ value: Constants.DOCUMENT_TYPES.PASSPORT.toString(), label: 'Pasaporte' },
		],
		photo_active: PHOTOS_ACTIVE.DOCUMENT_PHOTO
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Verificación de usuario',
				subtitle: 'Consulta y analiza todas las verificaciones realizadas en el sistema.',
				color: '#ebf9f2',
				icon: MenuIcons.Menu9,
				onBack: () => {
					this.props.history.replace(((this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) ? '/client' : '/admin') + '/verifications');
				}
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		// @ts-ignore
		const token_id: number = this.props.match?.params?.id;

		if (!token_id) {
			this.props.history.replace(((this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) ? '/client' : '/admin') + '/verifications');
		}

		const res: any = await ReportService.admin.viewVerification({
			token_id,
			page: this.state.page,
			withoutLoading,
			first_load: this.state.first_load
		});
		if (!res.identity_token || (res.identity_token?.user_id !== this.props.user?.id && res.identity_token?.user_id !== this.props.user?.user_id && (this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR))) {
			this.props.history.replace(((this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) ? '/client' : '/admin') + '/verifications');
			return;
		}
		this.setState({
			verification: res.verifications.rows.length > 0 ? res.verifications.rows[0] : null,
			identity_token: res.identity_token,
			last_page: res.verifications.count,
			black_list: res.black_list || [],
			first_load: false,
			page: this.state.first_load ? res.verifications.count : this.state.page,
			photo_active: PHOTOS_ACTIVE.DOCUMENT_PHOTO
		});
	}

	setVisible = (value: boolean) => {
		this.setState({
			visible: value
		});
	}

	view = (url: string) => {
		this.setState({
			visible: true,
			file: url
		});
	}

	changeStatus = (type: number) => {
		this.setState({
			visible_modal: true,
			type
		});
	}

	changeVerification = () => {
		const verification: any = this.state.verification;
		if (!verification?.document) {
			Globals.showError("Para cambiar el estatus de este registro, por favor indique el número de documento en su casilla correspondiente");
			return;
		}

		this.setState({
			visible_modal: true,
			type: Constants.CHANGE_VERIFICATION_TYPES.RESULT
		});
	}
	
	onClose = () => {
		this.setState({
			visible_modal: false,
			type: null
		},() => this.load());
	}

	setBlackList = async (e: any, value: string, is_mac = false) => {
		e.stopPropagation();
		await ReportService.admin.addBlackList({
			[is_mac ? 'mac' : 'image']: value,
			// @ts-ignore
			identity_verification_id: this.state.verification?.id
		});
		this.load(true);
	}

	saveStatus = (result: boolean, text: string) => {
		Globals.confirm(`¿Desea cambiar el estatus a ${ text }?`,async () => {
			await ReportService.admin.saveStatus({
				type: this.state.type,
				// @ts-ignore
				verification_id: this.state.verification?.id,
				result,
				manual_verification_by_id: this.props.user?.id
			});
			Globals.showSuccess("Se ha cambiado el estatus correctamente");
			this.onClose();
		});
	}

	getColor = () => {
		let color = '';

		// @ts-ignore
		switch(this.state.verification?.result) {
			case Constants.IDENTITY_VERIFICATION_RESULT.YES:
				color = Colors.green;
			break;

			case Constants.IDENTITY_VERIFICATION_RESULT.NO:
				color = Colors.danger;
			break;
		}

		return color;
	}

	edit = async (e: any) => {
		e.preventDefault();

		const verification: any = this.state.verification;

		// @ts-ignore
		const document_type = Object.values(Constants.DOCUMENT_TYPES)[Object.keys(Constants.DOCUMENT_TYPES).indexOf(verification?.document?.slice(0,1))] || '';

		if (!document_type) {
			await this.setState({
				form: {
					...this.state.form,
					document: verification?.document,
					document_type_id: verification?.document != null && verification?.document != '' ? Constants.DOCUMENT_TYPES.PASSPORT : ''
				}
			});
		}
		else {
			await this.setState({
				form: {
					...this.state.form,
					document: verification?.document?.slice(1) || '',
					document_type_id: document_type
				}
			});
		}

		this.setState({
			visible_update: true
		});
	}

	onCloseUpdate = () => {
		this.setState({
			visible_update: false
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	saveDocument = async () => {
		if (!this.state.form.document || !this.state.form.document_type_id) {
			Globals.showError("Por favor ingrese todos los datos para continuar");
			return;
		}

		let _document = this.state.form.document;
		let document_type_id = Constants.BRAVEALO_DOCUMENT_TYPES.ID;

		// @ts-ignore
		if (this.state.form.document_type_id == Constants.DOCUMENT_TYPES.PASSPORT) {
			document_type_id = Constants.BRAVEALO_DOCUMENT_TYPES.PASSPORT;
		}
		else {
			// @ts-ignore
			const value = Object.keys(Constants.DOCUMENT_TYPES)[Object.values(Constants.DOCUMENT_TYPES).indexOf(parseInt(this.state.form.document_type_id))];

			_document = value + _document;
		}

		await ReportService.admin.saveDocument({
			// @ts-ignore
			verification_id: this.state.verification?.id,
			updated_by_id: this.props.user?.id,
			document: _document,
			document_type_id
		});
		this.load(true);
		Globals.showSuccess("Se ha cambiado el número de documento correctamente");
		this.onCloseUpdate();
	}

	render() {
		const verification: any = this.state.verification;
		const identity_token: any = this.state.identity_token;
		const { visible, visible_modal, visible_update, photo_active } = this.state;
		const document_photo_in_black_list = this.state.black_list.map((i: any) => i.image).indexOf(verification?.document_photo) != -1;
		const selfie_in_black_list = this.state.black_list.map((i: any) => i.image).indexOf(verification?.selfie) != -1;
		const mac_in_black_list = this.state.black_list.map((i: any) => i.mac).indexOf(verification?.mac) != -1;
		const is_vehicle = verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.VEHICLE_CARD || verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.MEDICAL_CERTIFICATE;
		const document_photo = photo_active == PHOTOS_ACTIVE.DOCUMENT_PHOTO ? verification?.document_photo : verification?.document_back_photo;
		const available_country = verification?.cases?.find((i: any) => i.verification_case_id == Constants.VERIFICATION_CASES.INVALID_COUNTRY) == null;

		return (
			<div id="view-verification">
				<Viewer
			      visible={ visible }
			      onClose={ () => this.setVisible(false) }
			      images={ [{ src: this.state.file }] }
			    />

			    <Modal
		          className="modal-change-status-verification"
		          visible={ visible_modal }
		          title="Cambiar estado"
		          onClose={ () => this.onClose() }
		        >
			        <div id="modal-change-status-verification">
			          <div className="row row-status">
			          	<div className="col-md-6 text-center">
			          		<button className="btn btn-danger" onClick={ () => this.saveStatus(false,'Rechazado') }>
			          			Rechazado
			          		</button>
			          	</div>
			          	<div className="col-md-6 text-center">
			          		<button className="btn btn-success" onClick={ () => this.saveStatus(true,'Aprobado') }>
			          			Aprobado
			          		</button>
			          	</div>
			          </div>
			        </div>
		      	</Modal>

		      	<Modal
		          className="modal-update-document"
		          visible={ visible_update }
		          title="Editar número de documento"
		          onClose={ () => this.onCloseUpdate() }
		        >
			        <div id="modal-update-document">
			        	<div className="container-select">
				          	<Select
								color="white"
								placeholder="Seleccionar"
								name="document_type_id"
								onChange={ (e: any) => this.change(e) }
								value={ this.state.form.document_type_id }
								options={ this.state.document_types } />
							<Input
								value={ this.state.form.document }
								name="document"
								placeholder="Número de Documento"
								onChange={ (e: any) => {
									this.change(e); 
								} } />
						</div>
						<div className="text-center">
							<button className="btn btn-success" onClick={ () => this.saveDocument() }>
			          			Guardar
			          		</button>
						</div>
			        </div>
		      	</Modal>

		      	{
	      			this.state.last_page > 1 && (
	      				<div className="text-right" style={{ width: '100%' }}>
			      			<Pagination 
			      				inverse={ true }
								pages={ this.state.last_page } 
								active={ this.state.page }
								onChange={ async (page: number) => {
									await this.setState({
										page: page
									});
									this.load();
								} } />
						</div>
	      			)
	      		}

		      	<div className="row" style={{ marginBottom: '20px' }}>
		      		<div className="col-md-4">
		      			<div className={ `container-status h-100 ${ !verification?.result ? 'red' : '' }` }>
		      				<div className="shield-container">
		      					<img src={ ShieldIcon } />
		      				</div>
		      				<div>
		      					<p>Estado</p>
			      				<h6>{ verification?.result_text }</h6>
			      				<div className="container-last-update">
			      					<p>Fecha de registro: { moment(verification?.created_at).isValid() ? moment(verification?.created_at).format('DD/MM/YYYY HH:mm') : '-' }</p>
			      				</div>
		      				</div>
		      			</div>
		      		</div>
		      		<div className="col-md-4">
		      			<div className="container-status h-100 blue">
		      				<p>ID de usuario</p>
		      				<p className="bold">{ identity_token?.value }</p>

		      				{
		      					verification?.mac && (
		      						<>
		      							<p>ID Dispositivo</p>
					      				<p className="bold">
					      					{ verification?.mac }
											{
												(checkPermission(Constants.MODULES.ADMIN_KYC,'write') || checkPermission(Constants.MODULES.KYC,'write')) && (
													<Tooltip title={ mac_in_black_list ? 'Eliminar de lista negra' : 'Agregar a lista negra' }>
														<img src={ mac_in_black_list ? BlackListRedIcon : BlackListBlueIcon } className="black-list-mac" onClick={ (e: any) => this.setBlackList(e,verification?.mac,true) } />
													</Tooltip>
												)
											}
					      				</p>
		      						</>
		      					)
		      				}
		      			</div>
		      		</div>
		      		<div className="col-md-4">
		      			<div className="container-status h-100 purple">
		      				{
			      				(checkPermission(Constants.MODULES.ADMIN_KYC,'write') || checkPermission(Constants.MODULES.KYC,'write')) && (
			      					<button className="btn btn-verify" onClick={ () => this.changeVerification() }>
										<img src={ PencilIcon } />
										Cambiar estado
									</button>	
			      				)
			      			}
		      			</div>
		      		</div>
		      	</div>

				<div className="row">
					<div className="col-md-6">
						<div className="container-blue white">
							<div className="container-title">
								<img src={ FormIcon2 } />
								<h3>Información</h3>
							</div>
							<hr />
							{
								verification != null && (
									<div className="row">
										<div className="row col-md-12" style={{ margin: '0px', padding: '0px' }}>
											{
												is_vehicle ? (
													<>
														<div className="col-md-12">
															{
																(this.props.user?.level_id == Constants.LEVELS.ADMIN || this.props.user?.level_id == Constants.LEVELS.MODERATOR) && (
																	<p className="value"><strong>Cliente:</strong> { identity_token?.user?.name } { identity_token?.user?.lastname }</p>
																)
															}
															<p className="name-title">Datos del usuario:</p>
															<div className="row">
																<div className="col-md-6">
																	<p className="value"><strong>Nombres:</strong> { identity_token?.request_name }</p>
																	<p className="value"><strong>Apellidos:</strong> { identity_token?.request_lastname }</p>
																	{
																		verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.VEHICLE_CARD ? (
																			<p className="value" style={{ marginBottom: '15px' }}><strong>Cédula:</strong> { verification?.vehicle_data?.document || '-' }</p>
																		) : (
																			<p className="value" style={{ marginBottom: '15px' }}><strong>Cédula:</strong> { verification?.document || '-' }</p>
																		)
																	}
																</div>
																{
																	verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.MEDICAL_CERTIFICATE && (
																		<div className="col-md-6">
																			<p className="value"><strong>Edad:</strong> { verification?.age }</p>
																			<p className="value"><strong>Expedición:</strong> { moment(verification?.document_expedition_date).isValid() ? moment(verification?.document_expedition_date).format('DD/MM/YYYY') : '-' }</p>
																			<p className="value"><strong>Vencimiento:</strong> { moment(verification?.document_expiration_date).isValid() ? moment(verification?.document_expiration_date).format('DD/MM/YYYY') : '-' }</p>
																		</div>
																	)
																}
															</div>
														</div>
														{
															verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.VEHICLE_CARD && (
																<>
																	<div className="col-md-6" style={{ marginBottom: '15px' }}>
																		<p className="value"><strong>Placa:</strong> { verification?.vehicle_data?.plate || '-' }</p>
																		<p className="value"><strong>Tipo de Vehículo:</strong> { verification?.vehicle_data?.type?.name || '-' }</p>
																		<p className="value"><strong>Serial:</strong> { verification?.vehicle_data?.serial || '-' }</p>
																		<p className="value"><strong>Capacidad de Carga:</strong> { verification?.vehicle_data?.weight ? (verification?.vehicle_data?.weight + ' KGS') : '-' }</p>
																		<p className="value"><strong>Color:</strong> { verification?.vehicle_data?.color?.name || '-' }</p>
																	</div>
																	<div className="col-md-6">
																		<p className="value"><strong>Marca:</strong> { verification?.vehicle_data?.brand?.name || '-' }</p>
																		<p className="value"><strong>Modelo:</strong> { verification.vehicle_data?.model?.name || '-' }</p>
																		<p className="value"><strong>Año:</strong> { verification?.vehicle_data?.year || '-' }</p>
																		<p className="value"><strong>Categoría:</strong> { verification?.vehicle_data?.category?.name || '-' }</p>
																	</div>
																</>
															)
														}
													</>
												) : (
													<>
														{
															(this.props.user?.level_id == Constants.LEVELS.ADMIN || this.props.user?.level_id == Constants.LEVELS.MODERATOR) && (
																<div className="col-md-12">
																	<p className="value"><strong>Cliente:</strong> { identity_token?.user?.name } { identity_token?.user?.lastname }</p>
																</div>
															)
														}
														<div className="col-md-6">
															
															<p className="name-title">Datos suministrados por el usuario:</p>
															<p className="value"><strong>Nombres:</strong> { identity_token?.request_name }</p>
															<p className="value"><strong>Apellidos:</strong> { identity_token?.request_lastname }</p>
															{
																(!verification?.name_verification) && (
																	<div className="alert-container">
																		<img src={ AlertIcon } />
																		<p>Datos del documento no coincide</p>
																	</div>
																)
															}
														</div>
														{
															verification != null && (
																<div className="col-md-6">
																	<p className="name-title">Datos Verificados:</p>
																	<p className="value"><strong>Nombres:</strong> { verification?.name }</p>
																	<p className="value"><strong>Apellidos:</strong> { verification?.lastname }</p>
																</div>
															)
														}
														{
															!verification.only_faces && (
																<>
																	<div className="col-sm-6">
																		<p className="bold">Fecha de Nacimiento</p>
																		<p className="value">{ moment(verification?.birthdate).isValid() ? moment(verification?.birthdate).format('DD/MM/YYYY') : '-' }</p>
																	</div>
																	<div className="col-sm-6 row">
																		<div className={ `col-sm-${ verification?.country_iso ? '6' : '12' }` }>
																			<p className="bold">Edad</p>
																			{
																				verification != null && (
																					<p className="value">{ moment(verification?.birthdate).isValid() ? Globals.calculateAge(verification?.birthdate) : '-' }</p>
																				)
																			}
																		</div>
																		{
																			verification?.country_iso && (
																				<div className="col-sm-6">
																					<p className="bold">País</p>
																					<p className="value">{ verification?.country_iso }</p>
																				</div>
																			)
																		}
																	</div>
																</>
															)
														}
														{
															(!verification?.birthdate_verification) && (
																<div className="col-md-6">
																	<div className="alert-container">
																		<img src={ AlertIcon } />
																		<p>Fecha de nacimiento no coincide</p>
																	</div>
																</div>
															)
														}
													</>
												)
											}

											<div className="alert-bottom">
												<img src={ InfoIcon } />
												<p>La información verificada proviene del análisis del documento y las validaciones del sistema.</p>
											</div>
										</div>
									</div>
								)
							}
						</div>
					</div>
					<div className="col-md-6">
						{
							verification != null && (
								<div className="container-blue white">
									<div className="container-title">
										<img src={ ShieldIcon } />
										<h3>Estado</h3>
									</div>
									<hr />
									{
										is_vehicle ? (
											<>
												<div className="title-check">
													<div>
														<div className={ `container-check` }>
															<img src={ CheckWhiteIcon } />
														</div>
													</div>
													<h4>Lectura de datos</h4>
												</div>
											</>
										) : (
											<>
												{
													!verification.only_faces && (
														<>
															<div className="title-check">
																<div>
																	<div className={ `container-check ${ (!verification?.name_verification || !verification?.birthdate_verification) ? 'red' : '' }` }>
																		<img src={ verification?.name_verification && verification?.birthdate_verification ? CheckWhiteIcon : CloseIcon } />
																	</div>
																</div>
																<h4>Datos suministrados</h4>
															</div>
															<div className="title-check">
																<div>
																	<div className={ `container-check ${ !verification?.name_verification ? 'red' : '' }` }>
																		<img src={ verification?.name_verification ? CheckWhiteIcon : CloseIcon } />
																	</div>
																</div>
																<h4>Nombres y apellidos</h4>
															</div>
															<div className="title-check">
																<div>
																	<div className={ `container-check ${ !verification?.birthdate_verification ? 'red' : '' }` }>
																		<img src={ verification?.birthdate_verification ? CheckWhiteIcon : CloseIcon } />
																	</div>
																</div>
																<h4>Fecha de Nacimiento</h4>
															</div>
															{
																verification?.document_type_id != Constants.BRAVEALO_DOCUMENT_TYPES.COLOMBIAN_ID && verification?.document_type_id != Constants.BRAVEALO_DOCUMENT_TYPES.GENERIC_ID && (
																	<div className="title-check">
																		<div>
																			<div className={ `container-check ${ !verification?.expiration_date_verification ? 'red' : '' }` }>
																				<img src={ verification?.expiration_date_verification ? CheckWhiteIcon : CloseIcon } />
																			</div>
																		</div>
																		<h4>Vencimiento del documento</h4>
																	</div>
																)
															}
															<div className="title-check">
																<div>
																	<div className={ `container-check ${ (!moment(verification?.birthdate).isValid() || Globals.calculateAge(verification?.birthdate) < 18) ? 'red' : '' }` }>
																		<img src={ (moment(verification?.birthdate).isValid() && Globals.calculateAge(verification?.birthdate) >= 18) ? CheckWhiteIcon : CloseIcon } />
																	</div>
																</div>
																<h4>Edad Mínima</h4>
															</div>
														</>
													)
												}
												<div className="title-check">
													<div>
														<div className={ `container-check ${ !verification?.face_verification ? 'red' : '' }` }>
															<img src={ verification?.face_verification ? CheckWhiteIcon : CloseIcon } />
														</div>
													</div>
													<h4>Reconocimiento facial</h4>
												</div>
												<div className="title-check">
													<div>
														<div className={ `container-check ${ (!verification?.liveness1 || !verification?.liveness2) ? 'red' : '' }` }>
															<img src={ verification?.liveness1 && verification?.liveness2 ? CheckWhiteIcon : CloseIcon } />
														</div>
													</div>
													<h4>Detección de persona real</h4>
												</div>
												{
													!verification.only_faces && (
														<>
															<div className="title-check">
																<div>
																	<div className={ `container-check ${ (!verification.document_object_verification) ? 'red' : '' }` }>
																		<img src={ verification.document_object_verification ? CheckWhiteIcon : CloseIcon } />
																	</div>
																</div>
																<h4>Documento de identidad no corresponde</h4>
															</div>
															{
																verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.GENERIC_ID && (
																	<div className="title-check">
																		<div>
																			<div className={ `container-check ${ (!available_country) ? 'red' : '' }` }>
																				<img src={ available_country ? CheckWhiteIcon : CloseIcon } />
																			</div>
																		</div>
																		<h4>País válido</h4>
																	</div>
																)
															}
														</>
													)
												}
											</>
										)
									}

									{
										verification?.manual_verification_by != null && (
											<div className="alert-container" style={{ marginTop: '15px' }}>
												<img src={ AlertIcon } />
												<p>Cambio de estatus manual por { verification?.manual_verification_by?.name } { verification?.manual_verification_by?.lastname } - { moment(verification?.manual_verification_at).format('DD/MM/YYYY HH:mm') }</p>
											</div>
										)
									}
								</div>
							)
						}
					</div>
					{
						verification != null && (
							<>
								<div className={ is_vehicle ? 'col-md-12' : 'col-md-6' }>
									<div className="container-gray">
										<div className="container-title">
											<img src={ ListIcon } />
											<h3>Documento</h3>
										</div>
										<div className="bg-blue" style={{ backgroundImage: `url(${PhotoBg1})` }}>
											{
												verification?.document_photo != null && (
													<div className="container-image" onClick={ () => this.view(Globals.generateS3(document_photo,verification.s3,verification?.s3_provider)) }>
														{
															verification?.document_back_photo && photo_active == PHOTOS_ACTIVE.DOCUMENT_BACK_PHOTO && (
																<button className="btn btn-arrow arrow-left" onClick={ (e: any) => {
																	e.stopPropagation();
																	this.setState({
																		photo_active: PHOTOS_ACTIVE.DOCUMENT_PHOTO
																	});
																} }>
																	<img src={ ArrowLeftBlack } />
																</button>
															)
														}
														<img src={ Globals.generateS3(document_photo,verification.s3,verification?.s3_provider) } />
														{
															!is_vehicle && (checkPermission(Constants.MODULES.ADMIN_KYC,'write') || checkPermission(Constants.MODULES.KYC,'write')) && (
																<div className="container-black-list" onClick={ (e: any) => this.setBlackList(e,document_photo) }>
																	<Tooltip title={ document_photo_in_black_list ? 'Eliminar de lista negra' : 'Agregar a lista negra' }>
																		<img src={ document_photo_in_black_list ? BlackListRedIcon : BlackListIcon } className="black-list" />
																	</Tooltip>
																</div>
															)
														}
														{
															verification?.document_back_photo && photo_active == PHOTOS_ACTIVE.DOCUMENT_PHOTO && (
																<button className="btn btn-arrow arrow-right" onClick={ (e: any) => {
																	e.stopPropagation();
																	this.setState({
																		photo_active: PHOTOS_ACTIVE.DOCUMENT_BACK_PHOTO
																	});
																} }>
																	<img src={ ArrowRightBlack } />
																</button>
															)
														}
													</div>
												)
											}
										</div>
										<div style={{ padding: '10px' }}>
											<div className="row">
												{
													!is_vehicle && (
														<div className="col-sm-6">
															<p className="bold">Número</p>
															<div className="container-edit">
																<p className="value">{ verification?.document || '-' }</p>
																<a href="#" onClick={ (e: any) => this.edit(e) }>
																	<img src={ PencilIcon } />
																</a>
															</div>
														</div>
													)
												}
												{
													!verification.only_faces && !is_vehicle && verification?.document_type_id != Constants.BRAVEALO_DOCUMENT_TYPES.COLOMBIAN_ID && verification?.document_type_id != Constants.BRAVEALO_DOCUMENT_TYPES.GENERIC_ID && (
														<div className="col-sm-6">
															<p className="bold">Válido Hasta</p>
															<p className="value">{ moment(verification?.document_expiration_date).isValid() ? moment(verification?.document_expiration_date).format('DD/MM/YYYY') : '-' }</p>
														</div>
													)
												}
											</div>

											<div className="row">
												{
													verification?.updated_by_id != null && (
														<div className="col-md-6">
															<div className="alert-container">
																<img src={ AlertIcon } />
																<p>Cambio de número de documento por { verification?.updated_by?.name } { verification?.updated_by?.lastname }</p>
															</div>
														</div>
													)
												}
													
												{
													!verification?.document_object_verification && (
														<div className="col-md-6">
															<div className="alert-container">
																<img src={ AlertIcon } />
																<p>Documento no corresponde</p>
															</div>
														</div>
													)
												}
											</div>
										</div>
									</div>
								</div>
								{
									!is_vehicle && (
										<div className="col-md-6">
											<div className="container-gray">
												<div className="container-title">
													<img src={ ScanIcon } />
													<h3>Selfie</h3>
												</div>
												<div className="bg-blue" style={{ backgroundImage: `url(${PhotoBg1})` }}>
													{
														verification?.selfie != null && (
															<div className="container-image" onClick={ () => this.view(Globals.generateS3(verification?.selfie,verification?.s3,verification?.s3_provider)) }>
																<img src={ Globals.generateS3(verification?.selfie,verification?.s3,verification?.s3_provider) } />
																{
																	(checkPermission(Constants.MODULES.ADMIN_KYC,'write') || checkPermission(Constants.MODULES.KYC,'write')) && (
																		<div className="container-black-list" onClick={ (e: any) => this.setBlackList(e,verification?.selfie) }>
																			<Tooltip title={ selfie_in_black_list ? 'Eliminar de lista negra' : 'Agregar a lista negra' }>
																				<img src={ selfie_in_black_list ? BlackListRedIcon : BlackListIcon } className="black-list" />
																			</Tooltip>
																		</div>
																	)
																}
															</div>
														)
													}
												</div>
												<div style={{ padding: '10px' }}>
													<p className="facial-title">Probabilidad de coincidencia con documento: <span>{ (verification?.face_verification_percentage || 0).toFixed(0) }%</span></p>
												</div>
											</div>
										</div>
									)
								}
							</>
						)
					}
				</div>
				{
					verification != null && !is_vehicle && (
						<>
							<div className="row">
								{
									(verification?.face1_file || verification?.face2_file || verification?.liveness_link) && (
										<div className="col-md-8">
											<div className="row">
												{
													verification?.face1_file && (
														<div className="col-md-6">
															<div className="container-gray">
																<div className="container-title">
																	<img src={ ScanIcon } />
																	<h3>Detección de persona real</h3>
																</div>
																<div className="bg-blue" style={{ backgroundImage: `url(${PhotoBg1})` }}>
																	<div className="container-image" onClick={ () => this.view(Globals.generateS3(verification?.face1_file,verification.s3,verification?.s3_provider)) }>
																		<img src={ Globals.generateS3(verification?.face1_file,verification.s3,verification?.s3_provider) } />
																	</div>
																</div>
															</div>
														</div>
													)
												}
												{
													verification?.face2_file && (
														<div className="col-md-6">
															<div className="container-gray">
																<div className="container-title">
																	<img src={ ScanIcon } />
																	<h3>Detección de persona real</h3>
																</div>
																<div className="bg-blue" style={{ backgroundImage: `url(${PhotoBg1})` }}>
																	<div className="container-image" onClick={ () => this.view(Globals.generateS3(verification?.face2_file,verification.s3,verification?.s3_provider)) }>
																		<img src={ Globals.generateS3(verification?.face2_file,verification.s3,verification?.s3_provider) } />
																	</div>
																</div>
															</div>
														</div>
													)
												}
												{
													verification?.liveness_link && (
														<div className="col-md-6">
															<div className="container-gray">
																<div className="container-title">
																	<img src={ ScanIcon } />
																	<h3>Detección de persona real</h3>
																</div>
																<div className="bg-blue" style={{ backgroundImage: `url(${PhotoBg1})` }}>
																	<div className="container-image" onClick={ () => this.view(Globals.generateS3(verification?.liveness_link?.image,true,verification?.liveness_link?.s3_provider)) }>
																		<img src={ Globals.generateS3(verification?.liveness_link?.image,true,verification?.liveness_link?.s3_provider) } />
																	</div>
																</div>
															</div>
														</div>
													)
												}
											</div>
										</div>
									)
								}
								<div className="col-md-4">
									{
										verification?.rif != null && (
											<div className="container-gray">
												<div className="container-title">
													<img src={ ListIcon } />
													<h3>RIF</h3>
												</div>
												<div className="bg-blue" style={{ backgroundImage: `url(${PhotoBg1})` }}>
													<div className="container-image" onClick={ () => this.view(Globals.generateS3(verification?.rif,verification.s3,verification?.s3_provider)) }>
														<img src={ Globals.generateS3(verification?.rif,verification.s3,verification?.s3_provider) } />
													</div>
												</div>
											</div>
										)
									}
								</div>
							</div>
						</>
					)
				}

				<div className="alert-bottom">
					<img src={ LockIcon } />
					<p>La información mostrada en esta vista es confidencial y solo debe ser utilizada para fines de verificación y cumplimiento normativo</p>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ViewVerification);